import * as React from "react";

import { Dialog, Grid, Slide, Typography, makeStyles } from "@material-ui/core";
import Image from "next/image";

import RoundButton from "../../../common/button/RoundButton";
import done from "../../../../public/assets/images/done.png";

// import { useRouter } from "next/router";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
  root: (props) => ({
    backdropFilter: props.open ? "blur(2px)" : "none",
    width: "480px",
    margin: "auto",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  }),
  row: {
    padding: 20,
  },
  t1: {
    color: "#30c0b0",
    textAlign: "center",
    paddingBottom: 20,
    fontSize: "16px",
  },
  btnParent: {
    padding: "20px 50px",
  },
}));

const SuccessDialog = ({ open, setOpen, ...props }) => {
  const classes = useStyles({ open });

  // const router = useRouter();

  const handleClose = () => {
    // router.push("/profile");
    window.location.reload();
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={handleClose}
      keepMounted
      scroll="paper"
      maxWidth="xl"
      className={classes.root}
    >
      <Grid container className={classes.row} justifyContent="center">
        <Grid item xs={12} className={classes.t1}>
          <Typography variant="h4">
            پرداخت مهربانانه شما با موفقیت ثبت و در انتظار تایید قرار گرفت
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Image
            src={done}
            placeholder="blur"
            width={2}
            height={1}
            layout="responsive"
          />
        </Grid>
        <Grid item xs={12} className={classes.btnParent}>
          <RoundButton onClick={handleClose} fullWidth className={classes.btn}>
            متوجه شدم
          </RoundButton>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default SuccessDialog;
